"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../component");
exports.default = new class TimeComponent extends component_1.default {
    defaultOptions = { hour: true, minute: true, second: true, background: "blue", bold: true, padding: 1 };
    get(options) {
        const date = new Date;
        const timeFast = [["date", "getDate"], ["hour", "getHours"], ["minute", "getMinutes"], ["second", "getSeconds"], ["millisecond", "getMilliseconds"]];
        let text = "";
        for (let i = 0, k = 0; i < timeFast.length; i++) {
            const [opt, fn] = timeFast[i];
            if (options[opt]) {
                let value = date[fn]();
                if (opt === "hour" && options.hour12 && value > 12)
                    value -= 12;
                const length = options[opt + "Length"] ?? 2;
                text += (k > 0 ? (opt === "millisecond" ? "." : ":") : "") + value.toString().padStart(length, "0").substring(0, length);
                k++;
            }
        }
        if (options.hour12)
            text += " " + (date.getHours() > 12 ? "PM" : "AM");
        return text;
    }
    ;
};
